import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import themes from '../../theme-map';

@Component({
  selector: 'cc-lg-color-bubble',
  templateUrl: './color-bubble.component.html',
  styleUrls: ['./color-bubble.component.scss']
})
export class ColorBubbleComponent implements OnInit {
  @Input() control: FormControl;
  @Input() color: string;

  backgroundColor: string;
  fontColor: string;

  constructor() {}

  ngOnInit() {
    this.backgroundColor = themes[this.color].backgroundColor;
    this.fontColor = themes[this.color].fontColor;
  }
}
